<template>
    <div>
        <v-list>
            <v-list-item-group v-model="$i18n.locale" color="primary">
                <v-list-item
                    v-for="(lang, i) in linguistic"
                    :key="`lang-${i}`"
                    :value="lang.language"
                    style="margin:0 20px;padding:0 10px 0 16px"
                    @click="changeLocale(lang.language)"
                >
                    <v-list-item-content >
                        <v-list-item-title  class="btn-nav-text" >
                            {{ lang.title}}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>
        
    </div>
</template>

<script>
import i18n from './index'


export default {
name: 'SelectLocale',
data() {
    return { 
        linguistic: [
            {
                language: 'EN',
                title: 'English'

            },
            {
                language: '中文',
                title: '中文'
            },
            {
                language: 'BM',
                title: 'Malay'
            },
            {
                language: '한국',
                title: '한국어'
            },
            
        ]
    }
},
created() {
    this.changeLocale()
},
methods: {
    changeLocale(locale) {
        let urlParamsArray = window.location.hash.split("&")
            const langFunction = (locale)=>{
            if( locale == 'EN'){
                return "lang=en"
            }else if(locale == '中文'){
                return "lang=中文"
            }
            else if(locale == 'BM'){
                return "lang=bm"
            }
            else if(locale == '한국'){
                return "lang=한국"
            }
            }

            if( locale == undefined || locale == null){
                // console.log('url')
            }else{
                let result = urlParamsArray.filter(data => data.substring(0,4) !== "lang")
                result.push(langFunction(locale))
                
                let newResult = result.join('&')
                // console.log(newResult)
                history.replaceState( {}, '', newResult)
            }

    },
}
}
</script>
<style lang="less">

</style>